// Each media category's colour and icon, shared by the photo and document
// tabs (section headers, filter chips). Colours differ in lightness as well
// as hue, and every `color` reads at 4.5:1 or better on its `tint`.

// XRay's icon is our own (a film with a tooth, in src/theme/Base.scss):
// Font Awesome's fa-x-ray is a chest X-ray.
export const CATEGORY_THEME = {
  IntraOralPhoto: { label: "Intra-Oral", color: "#a8394d", tint: "#fcebee", icon: "fas fa-tooth" },
  ExtraOralPhoto: { label: "Extra-Oral", color: "#8a4b05", tint: "#fdf1dc", icon: "far fa-smile" },
  XRay: { label: "X-Ray", color: "#3730a3", tint: "#eceefe", icon: "dc-icon-xray" },
  OpdCard: { label: "OPD Card", color: "#0f5f59", tint: "#e2f4f1", icon: "far fa-id-card" },
  Document: { label: "เอกสาร", color: "#1f4fa3", tint: "#e8f0fc", icon: "far fa-file-alt" },
  Template: { label: "แบบฟอร์มคลินิก", color: "#3d4557", tint: "#eef0f4", icon: "far fa-clipboard" },
};

// Groups that are not a category (photos by treatment date).
export const NEUTRAL_THEME = { color: "#3d4557", tint: "#eef0f4", icon: "far fa-calendar" };

// The document tab's "สร้างเอกสาร" groups.
export const DOCUMENT_GROUP_THEME = {
  cert: { color: "#1f4fa3", tint: "#e8f0fc", icon: "far fa-file-alt" },
  consent: { color: "#5b21b6", tint: "#f1ebfe", icon: "fas fa-signature" },
  template: { color: "#0f5f59", tint: "#e2f4f1", icon: "far fa-clipboard" },
};

export function categoryTheme(category) {
  return CATEGORY_THEME[category] || NEUTRAL_THEME;
}
